import React from 'react';
import t from 'tcomb-form';
import types from '../forms/validators/index';
import AltIso from 'alt/utils/AltIso';
import connectToStores from 'alt/utils/connectToStores';

import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';
import withRouter from '../utils/with-router';

import SeoActions from '../actions/SeoActions';
import CurrentUserStore from '../stores/CurrentUserStore';
import FlatPageStore from '../stores/FlatPageStore';
import CurrentUserActions from '../actions/CurrentUserActions';

import FbLogin from '../components/FbLogin';
import TermsModal from '../components/TermsModal';
import RegistrationForm from '../forms/RegistrationForm';

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Sign Up');
            resolve();
        }),
        CurrentUserStore.getCurrentUser(),
        FlatPageStore.getPages()
    ]);
})

@connectToStores

@withRouter
class SignupView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newRole: null,
            isOpen: false
        };
    }

    static getPropsFromStores() {
        return {
            userStore: CurrentUserStore.getState(),
            pages: FlatPageStore.getState()
        };
    }

    static getStores() {
        return [CurrentUserStore, FlatPageStore];
    }

    getUser(){
        var peep = this.props.userStore.profile || {}; // there is no company at first load
        if (peep['has_valid_email'] === false){
            delete peep['email'];
        }
        return peep
    }

    componentDidMount() {
        const query = this.context.router.getCurrentQuery();
        this.setState({'new':query.role || false});
        this.getUser();
    }

    setRoleChoice(choice, e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({'newRole': choice});
    }

    renderRegistrationForm(){
        const bsnFields = ['first_name', 'last_name', 'email', 'company_name', 'phone', 'password'];
        const proFields = ['first_name', 'last_name', 'email', 'phone', 'password'];
        const fieldInformation = {
            first_name : {
                name : 'first_name',
                type: t.Str
            },
            last_name : {
                name : 'last_name',
                type: t.Str
            },
            email : {
                name : 'email',
                type: types.email
            },
            company_name : {
                name : 'company_name',
                type: t.Str
            },
            phone : {
                name : 'phone',
                type: t.Str
            },
            password : {
                name : 'password',
                type: t.Str
            }
        };

        let fields;
        if (this.state.newRole === 'bsn'){
            fields = Array.from(bsnFields);
        } else if (this.state.newRole === 'pro') {
            fields = Array.from(proFields);
        }

        if (this.props.userStore.isAuthenticated === true){
            var i = fields ? fields.indexOf("password") : -1;
            if(i != -1) {
                fields.splice(i, 1);
            }
        }
        let struct_info = {};

        if (fields) {
            for (let i = 0; i < fields.length; i++) {
                struct_info[fields[i]] = fieldInformation[fields[i]].type;
            }
        }

        const RegistrationModel = t.struct(struct_info);
        return <RegistrationForm initialFormData={this.getUser()} model={RegistrationModel} errors={this.props.userStore.registerError} ref="form" />;
    }

    renderFormArea() {
        let signee = this.state.newRole == 'bsn' ? "Company" : "Professional";
        return (
           <div className="view-content">
                <img className="site-logo" src={require('../styles/images/site-logo.svg')} alt="Gigpanel" />

                <form className="whitebox signup-form" onSubmit={this.doRegister.bind(this)} noValidate>
                    <h1>{signee} sign up</h1>
                    <FbLogin buttonText="Sign up with facebook"/>
                    {this.renderRegistrationForm()}
                    <p className="signup-tos">By signing up you agree with the <a href="#" onClick={this.toggleTermsModal.bind(this)}>terms of service.</a></p>
                </form>
                <p className="signup-cta">Already have an account?
                    <Link to="login"> Log in</Link>
                </p>
            </div>
        );
    }

    toggleTermsModal() {
        this.setState({isOpen: true});
    }

    toggleModal(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    doRegister(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;

        if (errors) {
            CurrentUserActions.failRegister(errors)
        }

        if (data) {
            let d = {};
            Object.keys(data).map(function(key){
                d[key] = data[key];
            });
            d['role'] = this.state.newRole;
            CurrentUserStore.register(d);
        }
    }

    getPageContent(url){
        const pages = this.props.pages.pages;
        for (let i= 0; pages.length; i++){
            if (pages[i] && pages[i].url === url){
                return pages[i];
            }
        }
        return "";
    }

    renderPopupArea(){
        return (
            <div className="choice-background">
                <div className="choice-area">
                    <h1>Are you business or professional?</h1>
                    <p>Please identify if you are a business customer looking for professionals or you are a professional looking for a work.</p>
                    <ul className="clearfix">
                        <li onClick={this.setRoleChoice.bind(this, 'bsn')}>
                            <h2>Business</h2>
                            <img className="choice" src={require('../styles/images/business_choice.png')} alt="Choose business" />
                            <a className="btn btn-green btn-small">Sign up</a>
                        </li>
                        <li onClick={this.setRoleChoice.bind(this, 'pro')}>
                            <h2>Professional</h2>
                            <img className="choice" src={require('../styles/images/professional_choice.png')} alt="Choose professional" />
                            <a className="btn btn-green btn-small">Sign up</a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const termsPage = this.state.newRole == 'pro' ? '/termspro/' : '/termsbsn/';
        let terms = this.getPageContent(termsPage);
        let localHTML;
        if ((this.props.userStore.isAuthenticated === true && this.props.userStore.profile.profile.role != "none") || this.state.newRole != null) {
            localHTML = this.renderFormArea();
        } else {
            localHTML = this.renderPopupArea();
        }

        return (
            <div className="view-signup maxwidth-wrapper">
                {localHTML}
                <TermsModal isVisible={this.state.isOpen} toggleModal={this.toggleModal.bind(this)} terms={terms} />
            </div>
        );
    }
}
export default SignupView;



/** WEBPACK FOOTER **
 ** ./app/src/views/SignupView.js
 **/